module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "topbar"
  }, [_c('a', {
    staticClass: "logoBox",
    attrs: {
      "href": '/' + _vm.Language + '/'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/eurotrader_logo_rgb_white.svg")
    }
  })]), _vm._v(" "), (!_vm.$auth.check()) ? _c('div', {
    staticClass: "regButtons"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('router-link', {
    staticClass: "button is-primary main login is-pulled-right",
    attrs: {
      "to": '/' + _vm.Language + '/login'
    }
  }, [_vm._v(_vm._s(_vm.$t('login').tUpper()))])], 1), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('router-link', {
    staticClass: "button is-primary main register is-pulled-right",
    attrs: {
      "to": '/' + _vm.Language + '/register'
    }
  }, [_vm._v(_vm._s(_vm.$t('register').tUpper()))])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100vw - 20px)",
      "height": "calc(100vh - 68px)",
      "z-index": "2",
      "position": "relative"
    },
    attrs: {
      "id": "webterminal"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "50%",
      "top": "50%",
      "transform": "translate(-50%, -50%)",
      "z-index": "1"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('content_ad_blocker_notice')) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf8ab77"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MT4WebClient.vue
// module id = 753
// module chunks = 0